// extracted by mini-css-extract-plugin
export var content = "_v3-1";
export var wrapper = "_v3-0";